import { api } from '../../config/ApiConfig';

export const Profile = {
  load: (included) => api.get(`/v1/users/me?${included ? included : ''}`),
  update: (data) => api.put('/v1/users/me', data),
  delete: () => api.delete('/v1/users/me')
}